export default __webpack_public_path__ + "static/IBMPlexSans-LightItalic-fb27393426073c6380ea6ac0a1d98f1d.woff";